/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginatedOrganisationMembersDataSchema = z.object({
	data: z.array(
		z.object({
			id: z.string(),
			email: z.string(),
			firstname: z.string().nullable(),
			lastname: z.string().nullable(),
			role: z.string().nullable(),
		}),
	),
	meta: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
})

export type PaginatedOrganisationMembersDataSchema = z.infer<typeof paginatedOrganisationMembersDataSchema>
